import { SelectField } from '../select-field';
import { FC } from 'react';
import map from 'lodash/map';
import { SelectFieldProps } from '../select-field/SelectField';
import { usePlaceService } from '../../../core/hooks/usePlaceService';
import { PlaceServiceDto } from '../../../core/http';

export const PlaceServiceField: FC<Omit<SelectFieldProps, 'items'>> = ({
  value,
  ...props
}) => {
  const { items } = usePlaceService();

  const selectItems = map(items, (item: PlaceServiceDto) => ({
    value: item.uuid,
    label: item.title || item.code
  }));

  return (
    <SelectField
      label="Location"
      value={value || ''}
      items={selectItems}
      {...props}
    />
  );
};
